import { usePDF } from '@react-pdf/renderer';
import React, { useEffect, useMemo } from 'react';

import MaintanceDocument from '../../../../../PDF/MaintanceReport/MaintanceDocument';
import useSignatureUrls from 'hooks/useSignatureUrls';

function MaintancePDF(props) {
  const { report, items, config } = props;
  const { id_maintance_report: idReport } = report;

  const { urls, ready } = useSignatureUrls({
    specialist_signature: report?.specialist_signature,
    recepcionist_signature: report?.recepcionist_signature,
  });

  const document = useMemo(() => {
    const reportForPDF = {
      ...report,
      specialist_signature: ready ? urls.specialist_signature : null,
      recepcionist_signature: ready ? urls.recepcionist_signature : null,
    };
    return <MaintanceDocument config={config} report={reportForPDF} items={items} />;
  }, [report, items, config, ready, urls]);

  // usePDF@4 captura el document solo al montar; forzamos update cuando
  // las firmas se resuelven.
  const [instance, updateInstance] = usePDF({ document });
  useEffect(() => {
    if (document) updateInstance(document);
  }, [document, updateInstance]);

  if (!ready || instance.loading) return <div>Cargando...</div>;
  if (instance.error) return <div>Algo salió mal: {instance.error}</div>;

  return (
    <div>
      <a
        href={instance.url}
        download={`Informe de Mantención N°${idReport}.pdf`}
      >
        Descargar Informe
      </a>
    </div>
  );
}


export default MaintancePDF;
